import { render, staticRenderFns } from "./transferVoucher.vue?vue&type=template&id=2a7737d8&scoped=true&"
import script from "./transferVoucher.vue?vue&type=script&lang=js&"
export * from "./transferVoucher.vue?vue&type=script&lang=js&"
import style0 from "./transferVoucher.vue?vue&type=style&index=0&id=2a7737d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7737d8",
  null
  
)

export default component.exports